module.exports = __webpack_public_path__ + "static/media/roi-footer-wide.69dfde89.jpg";